export default __webpack_public_path__ + "static/media/app_screen_search.751351f5.png";